'use client'

import { useId } from 'react'

type Props = {
    fromColor: string
    toColor: string
}

const borderWidth = 5
export const gradientBorderRadius = 12

const GradientBorder = ({ fromColor, toColor }: Props) => {
    const id = useId().replace(/:/g, '')
    const gradientId = `gradient-border-${id}`
    const maskId = `gradient-border-mask-${id}`
    const innerRadius = gradientBorderRadius - borderWidth

    return (
        <svg aria-hidden className="pointer-events-none absolute inset-0 size-full overflow-visible" focusable="false">
            <defs>
                <linearGradient id={gradientId} x1="0%" x2="100%" y1="0%" y2="100%">
                    <stop offset="0%" stopColor={fromColor} />
                    <stop offset="100%" stopColor={toColor} />
                </linearGradient>
                <mask id={maskId}>
                    <rect fill="white" height="100%" rx={gradientBorderRadius} width="100%" />
                    <rect
                        fill="black"
                        height={`calc(100% - ${borderWidth * 2}px)`}
                        rx={innerRadius}
                        width={`calc(100% - ${borderWidth * 2}px)`}
                        x={borderWidth}
                        y={borderWidth}
                    />
                </mask>
            </defs>
            <rect
                fill={`url(#${gradientId})`}
                height="100%"
                mask={`url(#${maskId})`}
                rx={gradientBorderRadius}
                width="100%"
            />
        </svg>
    )
}

export default GradientBorder
